(() => {
  if (window.STDProductInformation) {
    window.STDProductInformation.refresh(document);
    return;
  }
  function identify(text) {
  const value = text.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  if (/^(?:about (?:this|the) (?:cake|product)|description|product description|product details|our story|about (?:us|the supplier))\s*:?\s*$/i.test(value)) return { key: 'about', heading: true };
  if (/^(?:ingredients?(?:\s*(?:&|and)\s*allergens?)?|allergens?(?:\s*(?:information|advice|warning|statement))?|allergy (?:advice|information)|nutrition(?:al)?(?: information| facts)?|dietary(?: information| certified)?)\s*:?\s*$/i.test(value)) return { key: 'ingredients', heading: true };
  if (/^(?:sizes?(?:\s*(?:&|and)\s*servings?)?|servings?(?: per pack)?|serving size|dimensions?|weights?|net weight(?: of chocolate)?|pack size|box size|gift box (?:size|dimensions))\s*:?\s*$/i.test(value)) return { key: 'sizes', heading: true };
  if (/^(?:storage(?:\s*(?:&|and)\s*serving)?(?: instructions)?|shelf[\s-]*life|serving (?:instructions|suggestions)|heating(?: instructions)?|reheating(?: instructions)?|cooking instructions|how to (?:store|serve|heat))\s*:?\s*$/i.test(value)) return { key: 'storage', heading: true };
  if (/^(?:ingredients?|allergens?|allergy (?:advice|information)|nutrition(?:al)? information|contains\b|may contain\b|all products may contain\b|made in a (?:facility|kitchen).*(?:nuts|gluten|dairy|allergen)|we use (?:tree nuts|peanuts)|caution:)/i.test(value)) return { key: 'ingredients', heading: false };
  if (/^(?:sizes?\s*[:–—-]|(?:small|medium|large|mini|regular|family)\s*[:–—-]?\s*(?:approx\.?|\d)|serves\s+\d|servings?\s*[:–—-]|serving size\s*[:–—-]|dimensions?\s*[:–—-]|(?:net )?weight(?: of chocolate)?\s*[:–—-]|pack size\s*[:–—-]|gift box (?:measures|size|dimensions)\b)/i.test(value)) return { key: 'sizes', heading: false };
  if (/^(?:storage\s*[:–—-]|shelf[\s-]*life\s*[:–—-]|keep (?:refrigerated|frozen|in a cool)|store (?:in|at|below)|best served\b|best consumed\b|refrigerate\b|refrigeration\b|heat(?:ing)? (?:instructions|in)\b|reheat\b|cooking instructions\b|to (?:serve|store|reheat)\b)/i.test(value) || /\b(?:best consumed (?:fresh|within)|keep refrigerated|can be (?:refrigerated|frozen)|must be (?:refrigerated|frozen))\b/i.test(value)) return { key: 'storage', heading: false };
  if (/^(?:in (?:the year )?\d{4},|pasticceria papa|their famous|chocogram,|please note:|disclaimer:)/i.test(value)) return { key: 'about', heading: false };
  return null;
}
  const labels = {
    about: 'About this product',
    sizes: 'Sizes & servings',
    ingredients: 'Ingredients & allergens',
    storage: 'Storage & serving'
  };
  const textOf = node => node.textContent.replace(/\s+/g, ' ').trim();
  const meaningful = node => textOf(node) || (node.nodeType === 1 && (node.matches('img,svg,table,hr') || node.querySelector('img,svg,table,hr')));
  function fingerprint(root) {
    const texts = [];
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const text = walker.currentNode.textContent.replace(/\s+/g, ' ').trim();
      if (text) texts.push(text);
    }
    const media = Array.from(root.querySelectorAll('img,a,table')).map(node =>
      node.tagName + '|' + (node.getAttribute('src') || '') + '|' + (node.getAttribute('href') || '') + '|' + (node.tagName === 'TABLE' ? node.rows.length : '')
    );
    return JSON.stringify({ texts: texts.sort(), media: media.sort() });
  }
  function collect(root) {
    const units = [];
    function visit(node) {
      if (node.nodeType === 1 && /^(DIV|SECTION|ARTICLE)$/.test(node.tagName)) {
        Array.from(node.childNodes).forEach(visit);
      } else if (node.nodeType === 1 && node.tagName === 'P' && node.querySelector('br')) {
        const breaks = Array.from(node.querySelectorAll('br'));
        const segments = [];
        let startContainer = node;
        let startOffset = 0;
        breaks.concat([null]).forEach(br => {
          const range = document.createRange();
          range.setStart(startContainer, startOffset);
          if (br) range.setEndBefore(br);
          else range.setEnd(node, node.childNodes.length);
          const paragraph = node.cloneNode(false);
          paragraph.appendChild(range.cloneContents());
          if (meaningful(paragraph)) segments.push(paragraph);
          if (br) {
            startContainer = br.parentNode;
            startOffset = Array.prototype.indexOf.call(br.parentNode.childNodes, br) + 1;
          }
        });
        if (segments.some(paragraph => identify(textOf(paragraph)))) {
          segments.forEach(paragraph => units.push({ node: paragraph, text: textOf(paragraph), tag: 'P' }));
        } else {
          units.push({ node: node.cloneNode(true), text: textOf(node), tag: 'P' });
        }
      } else if (node.nodeType === 1 && node.tagName === 'UL') {
        const children = Array.from(node.childNodes);
        children.forEach(child => {
          if (child.nodeType === 1 && child.tagName === 'LI') {
            const list = node.cloneNode(false);
            list.appendChild(child.cloneNode(true));
            units.push({ node: list, text: textOf(child), tag: 'LI' });
          } else if (meaningful(child)) {
            units.push({ node: child.cloneNode(true), text: textOf(child), tag: child.nodeName });
          }
        });
      } else if (meaningful(node)) {
        units.push({ node: node.cloneNode(true), text: textOf(node), tag: node.nodeName });
      }
    }
    Array.from(root.childNodes).forEach(visit);
    return units;
  }
  function section(key, nodes) {
    const details = document.createElement('details');
    const summary = document.createElement('summary');
    summary.textContent = labels[key];
    const icon = document.createElement('span');
    icon.className = 'std-cake-toggle';
    icon.setAttribute('aria-hidden', 'true');
    summary.appendChild(icon);
    const content = document.createElement('div');
    content.className = 'rte std-product-info-content';
    nodes.forEach(node => content.appendChild(node));
    details.append(summary, content);
    return details;
  }
  function refine(root) {
    if (root.dataset.stdInformationReady === 'true') return;
    const source = root.querySelector('[data-std-description-content]');
    if (!source) return;
    root.dataset.stdInformationReady = 'true';
    if (source.querySelector('script,style,form,input,button,iframe,video,audio,details,[id]')) return;
    const units = collect(source);
    const groups = { about: [], sizes: [], ingredients: [], storage: [] };
    let current = 'about';
    units.forEach(unit => {
      const match = identify(unit.text);
      if (match) {
        groups[match.key].push(unit.node);
        current = match.heading ? match.key : 'about';
      } else {
        groups[current].push(unit.node);
      }
    });
    const replacement = document.createElement('div');
    replacement.className = 'std-cake-details std-product-information';
    Object.keys(labels).forEach(key => {
      if (!groups[key].length) return;
      const contentNodes = groups[key];
      const realContent = contentNodes.some(node => {
        const match = identify(textOf(node));
        return !match || !match.heading || node.querySelector && node.querySelector('img,table');
      });
      if (realContent) replacement.appendChild(section(key, contentNodes));
      else if (groups.about.length) {
        const about = replacement.querySelector('.std-product-info-content');
        if (about) contentNodes.forEach(node => about.appendChild(node));
      }
    });
    if (!replacement.children.length) return;
    const originals = fingerprint(source);
    const combined = document.createElement('div');
    replacement.querySelectorAll('.std-product-info-content').forEach(content => {
      Array.from(content.childNodes).forEach(node => combined.appendChild(node.cloneNode(true)));
    });
    if (originals !== fingerprint(combined)) return;
    root.replaceChildren(...replacement.childNodes);
  }
  function refresh(scope) {
    if (scope.matches && scope.matches('[data-std-product-information]')) refine(scope);
    scope.querySelectorAll('[data-std-product-information]').forEach(refine);
  }
  window.STDProductInformation = { refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh(document), { once: true });
  else refresh(document);
  document.addEventListener('shopify:section:load', event => refresh(event.target));
})();
